/**
 * Collection product cards: wishlist heart state via localStorage (handle list).
 * Works with <a> (navigates when adding) or <button> (toggle only).
 */
(function () {
  const STORAGE_KEY = 'cherubin-wishlist-handles';

  function getHandles() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  function saveHandles(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...new Set(handles)]));
  }

  function syncDom() {
    const set = new Set(getHandles());
    document.querySelectorAll('[data-card-wishlist-handle]').forEach((el) => {
      const handle = el.getAttribute('data-card-wishlist-handle');
      if (!handle) return;
      const saved = set.has(handle);
      el.classList.toggle('card__wishlist--saved', saved);
      if (el.tagName === 'BUTTON') {
        el.setAttribute('aria-pressed', saved ? 'true' : 'false');
      }
    });
  }

  function hrefIsNavigable(el) {
    if (el.tagName !== 'A') return false;
    const href = el.getAttribute('href');
    if (!href || href === '#' || href.trim() === '') return false;
    return true;
  }

  document.addEventListener('click', (e) => {
    const el = e.target.closest('[data-card-wishlist-handle]');
    if (!el) return;

    const handle = el.getAttribute('data-card-wishlist-handle');
    if (!handle) return;

    const handles = getHandles();
    const idx = handles.indexOf(handle);
    const saved = idx >= 0;
    const navigable = hrefIsNavigable(el);

    if (navigable) {
      if (saved) {
        e.preventDefault();
        handles.splice(idx, 1);
        saveHandles(handles);
        syncDom();
      } else {
        handles.push(handle);
        saveHandles(handles);
        syncDom();
      }
      return;
    }

    e.preventDefault();
    if (saved) {
      handles.splice(idx, 1);
    } else {
      handles.push(handle);
    }
    saveHandles(handles);
    syncDom();
  });

  function debounce(fn, ms) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  document.addEventListener('DOMContentLoaded', () => {
    syncDom();
    const productGrid = document.getElementById('product-grid');
    if (productGrid) {
      new MutationObserver(debounce(syncDom, 120)).observe(productGrid, { childList: true });
    }
    document.querySelectorAll('[data-wishlist-hydrate-root]').forEach((root) => {
      new MutationObserver(debounce(syncDom, 120)).observe(root, { childList: true, subtree: true });
    });
  });
  document.addEventListener('shopify:section:load', syncDom);
})();
